<div
  *ngIf="sugg_heading !== undefined && sugg_heading !== null"
  class="bg-white p-2 rounded fnt-size14px"
>
  <div class="suggested-slider">
    <p class="fnt-weight500 mb-2">{{ sugg_heading }}</p>
    <div class="row">
      <div
        class="pb-3"
        [ngClass]="{
          'col-md-6 col-lg-12': suggcallingfrom === 'showRightPart',
          'col-6': suggcallingfrom !== 'showRightPart'
        }"
        *ngFor="let sugglistObj of detailsuggList"
      >
        <div class="cursor-pointer border rounded">
          <app-detail-suggestion-card
            [callingfrom]="callingfrom"
            *ngIf="sugglistObj !== undefined"
            [sugglistObj]="sugglistObj"
          ></app-detail-suggestion-card>
        </div>
      </div>

      <!-- related journal -->
      <!-- <div class="bg-white connection-list mb-3 col-12 ">
                        <div class="p-2 border-bottom fnt-size14px">
                        <div class="row">
                            <div class="col-8">
                    <p class="fnt-size12px fnt-weight500">Related Jounrals</p>
                    </div>
                    <div class="col-4 text-right"><p class="text-success cursor-pointer fnt-size12px">View All</p></div>
                    </div>
                    </div>
                    <div class="pl-2 pr-2"> -->

      <!-- <div class=" " *ngFor="let sugglistObj of detailsuggList">
                    <div class="pt-2 cnnction-rqst bg-white connection-list mb-3 col-12 ">
                            <div class="row ">                      
                                    <div class="col-8 pr-0 fnt-size14px">
                                    <p class="mb-2 text-very-dark"><b>{{sugglistObj?.heading}}</b></p>
                                    <p class="mb-1 fnt-size12px text-light-grey"><span class="mr-2">#Oncology</span> <span class="mr-2">#Oncology</span></p>
                                    <p class="fnt-weight500 fnt-size12px text-medium-grey">by Docquity</p>
                                    
                                    </div>
                                    <div class="col-4"><div class="position-relative"><img class="rounded post-pic" style="height: 80px" src={{sugglistObj?.media?.media_url}} onerror="this.src='assets/images/grandround/image_placeholder.svg'"/>
                                    </div></div>
                                    <div class="col-8"><p class="fnt-size12px fnt-weight500 text-medium-grey mt-2"><span class="clinical-compny mr-4 position-relative"><img class="mr-1  post-pic rounded-circle" src="assets/images/bill-gate.jpg"/>Novartis</span><span class="clinical-compny mr-4 position-relative"><img class="mr-1  post-pic rounded-circle" src="assets/images/bill-gate.jpg"/>Novartis</span></p></div>
                                    <div class="col-4 mt-2 text-right">
                                            <span class="mr-4"><svg   width="20px"  id="Layer_ bookmarked" data-name="Layer  bookmarked"  viewBox="0 0 15 15"><defs><style>.cln-bookmark-card{fill:#737475;}</style></defs><path class="cln-bookmark-card" d="M11.54,12.84l-4-3.06-4,3.06v-10a.65.65,0,0,1,.65-.65h6.78a.65.65,0,0,1,.65.65Z"/></svg></span>
                                        <span><svg id="Layer_1" width="18px" data-name="Layer 1" viewBox="0 0 24 24"><defs><style>.edit-card-cln{fill:#737475;}</style></defs><ellipse class="edit-card-cln" cx="12" cy="4.84" rx="1.77" ry="1.84"/><ellipse class="edit-card-cln" cx="12" cy="12" rx="1.77" ry="1.84"/><ellipse class="edit-card-cln" cx="12" cy="19.16" rx="1.77" ry="1.84"/></svg></span>
                                        
                                    </div>
                            </div>
                        </div>
                    </div> -->
      <!-- </div>
                    </div> -->
    </div>

    <p class="fnt-weight500 mb-2" *ngIf="drugsuggList?.length > 0">
      Recommended Drug sample for you
    </p>
    <div
      class="pl-2 pr-2 bg-white"
      *ngFor="let drugListObj of drugsuggList; let i = index"
    >
      <app-suggestion-drug-sample-card
        *ngIf="drugListObj !== undefined"
        [drugListObj]="drugListObj"
      ></app-suggestion-drug-sample-card>
    </div>
  </div>
</div>
